"use client";

import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet.heat";

type HeatmapPoint = [number, number, number]; // [lat, lng, intensity]

type HeatmapLayerProps = {
  points: HeatmapPoint[];
};

const HeatmapLayer = ({ points }: HeatmapLayerProps) => {
  const map = useMap();
  const hasAdjustedBounds = useRef(false);

  useEffect(() => {
    if (!points || points.length === 0) return;

    // Filtrar pontos válidos e converter strings para números
    const validPoints = points
      .map((point) => {
        const lat =
          typeof point[0] === "string" ? parseFloat(point[0]) : point[0];
        const lng =
          typeof point[1] === "string" ? parseFloat(point[1]) : point[1];
        const intensity =
          typeof point[2] === "string" ? parseFloat(point[2]) : point[2];

        return [lat, lng, intensity] as [number, number, number];
      })
      .filter(
        (point) => !isNaN(point[0]) && !isNaN(point[1]) && !isNaN(point[2]),
      );

    if (validPoints.length === 0) return;

    console.log("Heatmap points:", validPoints);

    // @ts-ignore - leaflet.heat não tem tipos completos
    const heatLayer = L.heatLayer(validPoints, {
      radius: 30,
      blur: 20,
      maxZoom: 18,
      max: 1.0,
      minOpacity: 0.5,
      gradient: {
        0.0: "#3b82f6",
        0.5: "#eab308",
        1.0: "#ef4444",
      },
    }).addTo(map);

    // Ajustar zoom apenas na primeira vez
    if (!hasAdjustedBounds.current && validPoints.length > 0) {
      const bounds = L.latLngBounds(validPoints.map((p) => [p[0], p[1]]));
      map.fitBounds(bounds, { padding: [50, 50] });
      hasAdjustedBounds.current = true;
    }

    return () => {
      map.removeLayer(heatLayer);
    };
  }, [map, points]);

  return null;
};

type HeatmapLeafletProps = {
  points: HeatmapPoint[];
  center?: [number, number];
  zoom?: number;
  height?: string;
};

export const HeatmapLeaflet = ({
  points,
  center = [-3.7172, -38.5433], // Fortaleza como padrão
  zoom = 12,
  height = "400px",
}: HeatmapLeafletProps) => {
  return (
    <div
      style={{ height, width: "100%", borderRadius: "8px", overflow: "hidden" }}
    >
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <HeatmapLayer points={points} />
      </MapContainer>
    </div>
  );
};
